// extracted by mini-css-extract-plugin
module.exports = {"root":"embed-block_root__J6qdA"};